// Added by - Ashish Dewangan on 17-08-2024
// Reason - UI to render certificate details

import React, { useContext, useEffect, useState } from "react";
import { certificate } from "../../Api/services";
import certificateStyle from "./Certificates.module.css";
import parse from "html-react-parser";
import { baseURL } from "../../Api/config";

import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";

const Certificates = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);

  const [certificatePageDetails, setCertificatePageDetails] = useState("");
  const [certificates, setCertificates] = useState([]);
  /**
   * Added by - Ashish Dewangan on 17-08-2024
   * Reason - calling get API to get certificate page details
   */
  const fetchCertificatesData = async () => {
    try {
      const response = await certificate();
      setCertificatePageDetails(response.certificate_page_content.page_content);
      setCertificates(response.certificates);
    } catch (error) {
      console.error("Error fetching certificate details:", error);
    }
  };
  /**
   * End of code addition by - Ashish Dewangan on 17-08-2024
   * Reason - calling get API to get certificate page details
   */

  /**
   * Added by - Ashish Dewangan on 17-08-2024
   * Reason - calling fetchCertificatesData on page load,
   * that will call API to get certificate page details.
   */
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      // Code changed by - Ashlekh on 03-01-2025
      // Reason - To change name
      // { name: "Certificates", path: "/certificates" },
      {name: "Services and certificates", path: "/certificates"}
      // End of code - Ashlekh on 03-01-2025
      // Reason - To change name
    ]);

    /**
     * Added by - Ashish Dewangan on 17-08-2024
     * Reason - To scroll to the top of the page when page loads
     */
    window.scrollTo(0, 0);
    /**
     * End of code addition by - Ashish Dewangan on 17-08-2024
     * Reason - To scroll to the top of the page when page loads
     */

    fetchCertificatesData();
  }, []);
  /**
   * End of code addition by - Ashish Dewangan on 17-08-2024
   * Reason - calling fetchCertificatesData on page load,
   * that will call API to get certificate page details.
   */

  if (certificatePageDetails?.trim()?.length < 1 && certificates?.length < 1)
    /**
     * Modified by - Ashish Dewangan on 23-08-2024
     * Reason - To provide styling
     */
    // return <p>No details available</p>;
    return (
      <p className={certificateStyle.noDetailsAvailableText}>
        No details available
      </p>
    );
  /**
   * End of modification by - Ashish Dewangan on 23-08-2024
   * Reason - To provide styling
   */

  return (
    <div className={certificateStyle.mainContainer}>
      <div className={certificateStyle.certificatePageContentContainer}>
        <NavigationPath navigationPathArray={navigationPath} />
        {/*
         * Modified by - Ashish Dewangan on 22-08-2024
         * Reason - To provide page title
         */}
        {/* Code changed by - Ashlekh on 03-01-2025
        Reason - To change title  */}
        {/* <div className={certificateStyle.pageTitle}>Certifications</div> */}
        {/* Code changed by - Ashlekh on 08-01-2025
        Reason - To change title design */}
        <div className={certificateStyle.pageTitle}>Services and Certificates</div>
        {/* <div className={certificateStyle.pageTitle}>
          <img className={certificateStyle.headingImage} src="headingdesign.png" />
          <div className={certificateStyle.headingTitle}>
            <span className={certificateStyle.title1}>Se</span>
            <span className={certificateStyle.title2}>rvices and Certificates</span>
          </div>
        </div> */}
        {/* End of code - Ashlekh on 08-01-2025
        Reason - To change title design */}
        {/* End of code - Ashlekh on 03-01-2025
        Reason - To change title */}
        {/*
         * End of modification by - Ashish Dewangan on 22-08-2024
         * Reason - To provide page title
         */}
        {certificatePageDetails?.trim()?.length > 1 &&
          parse(certificatePageDetails)}
      </div>

      {certificates.length > 0 && (
        <div className={certificateStyle.certificatesImageContainer}>
          {certificates.map((certificate, index) => {
            return (
              <div className={certificateStyle.certificatesImageWrapper}>
                <img
                  src={baseURL + certificate.certificate_image}
                  className={certificateStyle.certificatesImage}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Certificates;
